import EditHub from './EditHub'

export default EditHub
